// Rotas. O papel da sessao decide o que a pessoa ve: equipe e admin nunca
// compartilham tela, e o telao nao exige login.

import { Navigate, Route, Routes } from "react-router-dom";
import { useSession } from "./lib/hooks.js";
import { Spinner } from "./components/ui.js";
import { LoginPage } from "./pages/Login.js";
import { BigScreen } from "./pages/public/BigScreen.js";
import { TeamLayout } from "./pages/team/TeamLayout.js";
import { TeamProblemsPage } from "./pages/team/ProblemsPage.js";
import { TeamProblemPage } from "./pages/team/ProblemPage.js";
import { TeamSubmissionsPage } from "./pages/team/SubmissionsPage.js";
import { TeamScoreboardPage } from "./pages/team/ScoreboardPage.js";
import { AdminLayout } from "./pages/admin/AdminLayout.js";
import { AdminContestPage } from "./pages/admin/ContestPage.js";
import { AdminTeamsPage } from "./pages/admin/TeamsPage.js";
import { AdminProblemsPage } from "./pages/admin/ProblemsPage.js";
import { AdminProblemEditPage } from "./pages/admin/ProblemEditPage.js";
import { AdminSubmissionsPage } from "./pages/admin/SubmissionsPage.js";
import { AdminSubmissionDetailPage } from "./pages/admin/SubmissionDetailPage.js";
import { AdminQueuePage } from "./pages/admin/QueuePage.js";
import { AdminScoreboardPage } from "./pages/admin/ScoreboardPage.js";
import { AdminsPage } from "./pages/admin/AdminsPage.js";

export function App(): React.JSX.Element {
  const session = useSession();

  if (session.isPending) return <Spinner label="Verificando sessao..." />;

  const user = session.data ?? null;

  return (
    <Routes>
      {/* Telao: sem login, para projetar. */}
      <Route path="/telao" element={<BigScreen />} />

      <Route
        path="/login"
        element={user ? <Navigate to={homeFor(user.role)} replace /> : <LoginPage />}
      />

      {user?.role === "team" && (
        <Route path="/" element={<TeamLayout />}>
          <Route index element={<Navigate to="/problemas" replace />} />
          <Route path="problemas" element={<TeamProblemsPage />} />
          <Route path="problemas/:id" element={<TeamProblemPage />} />
          <Route path="submissoes" element={<TeamSubmissionsPage />} />
          <Route path="placar" element={<TeamScoreboardPage />} />
        </Route>
      )}

      {user?.role === "admin" && (
        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<Navigate to="/admin/contest" replace />} />
          <Route path="contest" element={<AdminContestPage />} />
          <Route path="equipes" element={<AdminTeamsPage />} />
          <Route path="problemas" element={<AdminProblemsPage />} />
          <Route path="problemas/:id" element={<AdminProblemEditPage />} />
          <Route path="submissoes" element={<AdminSubmissionsPage />} />
          <Route path="submissoes/:id" element={<AdminSubmissionDetailPage />} />
          <Route path="fila" element={<AdminQueuePage />} />
          <Route path="placar" element={<AdminScoreboardPage />} />
          <Route path="administradores" element={<AdminsPage />} />
        </Route>
      )}

      <Route
        path="*"
        element={<Navigate to={user ? homeFor(user.role) : "/login"} replace />}
      />
    </Routes>
  );
}

function homeFor(role: "team" | "admin"): string {
  return role === "admin" ? "/admin/contest" : "/problemas";
}
